/* eslint-disable no-shadow */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { scroller } from 'react-scroll';
import {
  getOas,
  setOaName,
  getOaActivities,
  getActivitiesByTypeAndDate,
  clearActiveOa,
  getFilterOptions,
  getActivitiesOptions,
  setActiveOa,
} from '../../actions';
import Main from '../../Layouts/Main';
import Infos from '../../components/Infos/Infos';
import OasList from '../../components/OasList/OasList';
import Map from '../../components/Map/Map';
import Filter from '../../components/Filter/Filter';
import DateFilter from '../../components/Filter/DateFilter';
import InputSelect from '../../components/Input/Input';
import LocationWhiteIcon from '../../assets/location-icon-white.svg';
import { userType } from '../../utils/mockups';
import { isMobile } from '../../utils/helpers';
import './Search.css';

const safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

class Search extends React.Component {
  constructor(props) {
    super(props);
    props.history.listen((location) => {
      if (location.pathname === '/oa') {
        this.props.clearActiveOa();
      }
    });
  }

  componentDidMount() {
    this.loadData();
    this.props.getActivitiesOptions();
    this.props.getFilterOptions();
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeOa !== this.props.activeOa) {
      scroller.scrollTo(`oa-${nextProps.activeOa.seq_cadast}`, {
        containerId: 'oas-list-container',
        duration: 800,
        smooth: true,
        offset: -100,
      });
    }
  }

  loadData() {
    const {
      location: { pathname = '' },
      oas,
      oasError,
    } = this.props;
    const splittedPath = pathname.split('/');

    if (oas.length === 0 && oasError === '') {
      if (splittedPath.length === 3) {
        const part = splittedPath[2];
        this.props.getOas(part);
      } else {
        this.props.getOas();
      }
    }
  }

  handleRouteClick() {
    const { activeOa } = this.props;
    const link = `https://www.google.com/maps/dir//${activeOa.num_latitu.trim()},${activeOa.num_longit.trim()}`;
    window.open(link);
  }

  async handleSearchChange(val) {
    const { props } = this;
    if (val !== null) {
      props.setOaName(val[Object.keys(val)[0]]);
      props.getOas();
      if (val.seq_cadast && !isMobile) {
        this.props.history.push(`/oa/${val.seq_cadast}`);
      }
    }
  }

  render() {
    const { props } = this;
    const {
      oas,
      loading,
      activeOa,
    } = this.props;

    return (
      <Main>
        <header className={`search filters position-relative container ${activeOa.seq_cadast === 0 ? 'active' : ''}`}>
          <div className="mt-4 mb-4">
            <h2 className="m-0 results" style={{ fontSize: '24px' }}>
              {loading ? 'Pesquisando...' : oas.length >= 1 ? `${oas.length > 1 ? `${oas.length} Resultados` : '1 Resultado'} ` : 'Nenhum resultado'}
            </h2>
          </div>
          <div className="col-12 pl-0 pr-0">
            <InputSelect onChange={(val) => this.handleSearchChange(val)} options={props.oaNames} creatable placeholder="Pesquise por Cidade, Estado, CEP ou Nome do O.A" name="oaName" className="big" icon="searchIcon" />
          </div>

          <div className={`custom-filters filter-header ${safari ? 'filter-safari' : ''}`}>
            <Filter
              activity
              history={props.history}
              options={props.activitiesOptions}
              label={props.activityType}
              type="activity"
              searchFilter
            />

            <Filter
              activity
              history={props.history}
              options={userType}
              label={props.publicType}
              type="public"
            />
            <DateFilter
              history={props.history}
              activity
            />
            <Filter
              activity
              history={props.history}
              label={[]}
              type="clear"
              all
            />
          </div>
        </header>
        <div id="search" className="container">
          {loading ? (
            <div className={`col-12 pb-3 pt-3 d-flex justify-content-center ${props.oas.length > 0 ? 'col-md-4' : 'col-md-12'}`}>
              <div className="lds-ring">
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          ) : (
            <div id="oas-list-container" className={`oas container col-12 ${activeOa.seq_cadast === 0 ? 'active' : ''} ${props.oas.length > 0 ? 'col-md-4' : 'col-md-12'}`}>
              <OasList history={props.history} />
            </div>
          )}
          {
                        props.oas.length > 0 && (
                        <div className="col-12 col-md-8 oas-infos  ml-auto mr-auto p-0">

                          <div className="map-container">
                            <Map history={props.history} />
                            {activeOa.seq_cadast !== 0 && (
                            <div className="mt-3 mb-3 d-flex col-md-12 button-route">
                              <button className="btn d-flex" type="button" style={{ justifyContent: 'space-evenly' }} onClick={() => this.handleRouteClick()}>
                                <img src={LocationWhiteIcon} alt="Rotas" style={{ margin: '0 8px 0 0' }} />
                                                VER ROTA PARA O ORGANISMO
                              </button>
                            </div>
                            )}
                          </div>
                          <div className={`activities ${activeOa.seq_cadast ? 'active' : ''}`}>
                            <Infos history={props.history} />
                          </div>
                        </div>
                        )
                    }
        </div>
      </Main>
    );
  }
}

const mapStateToProps = (store) => ({
  oas: store.oasState.oas,
  oasError: store.oasState.error,
  activeOa: store.oasState.activeOa,
  loading: store.oasState.loading,
  oaName: store.filterState.oaName,
  oaNames: store.filterState.options,
  activitiesOptions: store.filterState.activitiesOptions,
  publicType: store.filterState.oaPublicType,
  activityType: store.filterState.oaActivityType,
  activityDate: store.filterState.oaActivityDate,

});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getOas,
  setOaName,
  getOaActivities,
  clearActiveOa,
  getFilterOptions,
  getActivitiesOptions,
  getActivitiesByTypeAndDate,
  setActiveOa,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Search);
